export const SAVE_IMPORT_WIZARD_SUCCESS = 'SAVE_IMPORT_WIZARD_SUCCESS_SUCCESS';
export type SAVE_IMPORT_WIZARD_SUCCESS = typeof SAVE_IMPORT_WIZARD_SUCCESS;

export interface SaveImportWizardSuccess {
    type: SAVE_IMPORT_WIZARD_SUCCESS;
}

export function saveImportWizardSuccessAction(): SaveImportWizardSuccess {
    return {
        type: SAVE_IMPORT_WIZARD_SUCCESS
    };
}
